// Outlook store: istanza provider-specifica del mail store generico.
// La logica vive in ./mail (factory createMailStore + outlookAdapter). Speculare
// a gmailStore.ts.
import { createMailStore } from './mail/createMailStore';
import { outlookAdapter } from './mail/adapters/outlookAdapter';

export const useOutlookStore = createMailStore(outlookAdapter);
